var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t( 'views.property.details.details' )))]),_c('p',[_vm._v(_vm._s(_vm.$t( 'views.property.details.details-info' )))]),_c('PropertyProfileForm',{attrs:{"property":_vm.property}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }